(function($) {
    "use strict";

    $(document).ready(function () {
        $('.table-flex').each(function () {
            var that = $(this);

            // Determine headings, if available
            if (that.find('thead tr:first th').length > 0) {
                var headings = that.find('thead tr:first th');
            } else {
                var headings = false;
            }

            if (window.innerWidth <= 767) {
                // Set table sections to blocks
                that.css('display', 'block');
                that.find('thead, tbody, tfoot').css('display', 'block');

                // Set table rows to flex
                that.find('tr').css({
                    display: 'flex',
                    'flex-direction': 'row',
                    'flex-wrap': 'nowrap',
                    'align-items': 'stretch',
                    'align-content': 'stretch',
                    'width': '100%'
                });

                // Work out sizes of each flex cell
                that.find('th, td').each(function () {
                    // Work out percentage of cell
                    var percentage = Math.floor(($(this).outerWidth() / that.width()) * 100);

                    $(this).css({
                        display: 'block',
                        flex: percentage + ' 1 0',
                        'word-wrap': 'break-word',
                        'overflow-wrap': 'break-word',
                        'word-break': 'break-word'
                    })
                });
            }

            // Add data headers to normal tbody cells if we have headers
            if (headings !== false) {
                that.find('tr').each(function () {
                    var index = 0;

                    $(this).find('th, td').each(function () {
                        if (headings[index] !== undefined) {
                            $(this).attr('data-header', $(headings[index]).text());
                            if ($(this).attr('colspan')) {
                                index += ($(this).attr('colspan') / 1);
                            } else {
                                index++;
                            }
                        }
                    });
                });
            }
        });
    });
})(jQuery);
